import { useChatContext } from "stream-chat-react";
import ProfileImageComp from "../../common/profile";
import { Cross } from "../../../icons";
import { useAppDispatch, useAppSelector } from "../../../hooks/store-hooks";
import { useEffect, useState } from "react";
import { getUser } from "../../../store/actions/chatActions";
import { useDebounce } from "../../../hooks/debounce-hooks";
import { useGetSearchDataQuery } from "../../../store/api/searchApi";

const ChatList = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onSelectUser = (data: any) => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  hideLeftPanel = (data: any) => {},
}) => {
  const dispatch = useAppDispatch();
  const { client: chatClient } = useChatContext();
  const { userData } = useAppSelector((state) => state.user);

  const [searchText, setSearchText] = useState("");
  const debouncedSearch = useDebounce(searchText, 500);
  const [users, setusers] = useState([]);
  const { data } = useGetSearchDataQuery(
    {
      q: debouncedSearch,
      type: "user",
    },
    { refetchOnMountOrArgChange: true },
  );

  const { _id: userChatId } = userData || {};
  const getSelectedChat = async (id: string) => {
    try {
      const user = await dispatch(getUser({ chatClient, userId: id })).unwrap();
      onSelectUser({ type: "message", user });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (data?.data) {
      const userResponse = data?.data?.users;
      setusers(
        userResponse?.filter(
          (user: any) => user?.id !== userChatId && user?.memberships?.is_opc,
        ),
      );
    }
  }, [data]);

  return (
    <div className="w-full bg-white rounded-lg relative">
      <div className="absolute top-0 left-0 bg-white w-full z-[11]">
        <div className="flex items-center justify-between p-4 py-3 border-b border-gray-200">
          <div className="flex items-center">
            <span className="ml-2 text-lg font-semibold">Messaging</span>
          </div>
          <div onClick={hideLeftPanel} className="cursor-pointer">
            <Cross />
          </div>
        </div>

        <div className="p-4 ">
          <input
            onChange={(e) => {
              setSearchText(e.target.value);
            }}
            type="text"
            placeholder="Search users"
            className="w-full px-4 py-2 text-sm border border-gray-300 rounded-md outline-none"
          />
        </div>
      </div>

      {/* Message List */}
      <div className="divide-y divide-gray-200 overflow-y-scroll chat-list-followed pt-28">
        {/* Example Message Item */}
        {searchText &&
          users.map((details: any, index: number) => {
            return (
              <div
                onClick={() => getSelectedChat(details?.id)}
                key={index}
                className="flex items-center justify-between p-4 py-3 hover:bg-gray-100 cursor-pointer"
              >
                <div className="flex items-center justify-start">
                  <div className="w-10 relative">
                    <ProfileImageComp
                      imageUrl={details?.profile_picture}
                      customClass="w-10 h-10 rounded-full"
                      is_opc={details?.memberships?.is_opc}
                    />
                  </div>
                  <div className="ml-3">
                    <h4 className="text-sm font-semibold text-gray-800 flex items-center">
                      {details?.first_name + " " + details?.last_name}
                    </h4>
                    <div className="text-xs text-gray-500 flex items-center">
                      {details?.designation && details?.company_name
                        ? details?.designation + " at " + details?.company_name
                        : details?.designation || details?.company_name}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ChatList;
